import { Component, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { SQLService } from '../../../services/sql.service';
import { backgrounds, backgrounds_lowrez } from '../../../../environments/logos';
@Component({
  selector: 'app-cheque-golden',
  templateUrl: './cheque-golden.component.html',
  styleUrls: ['./cheque-golden.component.scss'],
})
export class ChequeGoldenComponent implements AfterViewInit {
  constructor(private sql: SQLService) { }
  @Output('loaded') loaded = new EventEmitter<boolean>();
  @Input('RenderMICR') RenderMICR = false;
  @Input('ImageMICR') ImageMICR = true;
  @Input('show') show = 'table';
  @Input('cheque') cheque: any;
  @Input('design') design: any;
  @Input('designer') designer: any;
  @Input('rotate') rotate: boolean;
  @Input('borders') borders: boolean;
  @Input('voidcheck') voidcheck: boolean;
  @Input('font') font: any;
  @Input('fiat') fiat: boolean;
  @Input('color') color: any;
  @Input('micr') micr: any;
  micr_top=false;
  micr_right=false;
  micr_bottom='2.3mm';
  micr_left='8mm';
  @Input('secret') secret = '';
  @Input('scale') scale =1;
  @Input('fold_line') fold_line: boolean;
  @Input('template') template: string;
  @Input('monochrome') monochrome: boolean;
  @Input('gradients') gradients: boolean;
  @Input('margin_bottom') bottom = '0mm';
  @Input('margin_top') top = '0mm';
  @Input('fontsize') fontsize: boolean;
  @Input('layers') layers: any;
  @Input('translations') translations = this.sql.word;
  @Input('bold') bold: boolean;
  @Input('italic') italic: boolean;
  @Input('show_cheque_number') show_cheque_number: boolean = true;
  @Input('show_cheque_date') show_cheque_date: boolean = true;
  @Input('show_micr') show_micr: boolean = true;
  @Input('cheque_background_image_repeat') cheque_background_image_repeat = false;
  @Input('background_position') background_position: string;
  @Input('cheque_text_color') cheque_text_color: string;
  @Input('cheque_background_image') cheque_background_image: any;
  @Input('cheque_logo_image') cheque_logo_image: any;
  @Input('cheque_header_image') cheque_header_image: any;
  @Input('cheque_bank_image') cheque_bank_image: any;
  @Input('doc_color') doc_color: string = 'gold';
  bg_image: string;  
  loaded_component() {this.loaded.emit(true);}
  ngAfterViewInit() {
    this.design["height"]='77.8mm';
    this.design["date"]["top"]='49.8mm';
    this.design["date"]["right"]='32mm';
    this.design["date_label"]["display"]=false;
    this.design["payline"]["prefix"]=false;
    this.design["payline"]["borders"]=false;
    this.design["payline"]["top"]='32.5mm';
    this.design["payline"]["right"]='14mm';
    this.design["payline"]["bottom"]='1mm';
    this.design["payline"]["left"]='33.1mm';
    this.design["printed_id"]["top"]='13mm';
    this.design["printed_id"]["right"]='12mm';
    this.design["payment_name"]["left"]="9mm";
    this.design["payment_name"]["bottom"]="-2mm";
    this.design["written_amount"]["top"]='43.8mm';
    this.design["written_amount"]["right"]=false;
    this.design["written_amount"]["bottom"]='auto';
    this.design["written_amount"]["left"]='14.2mm';
    this.design["written_amount_line"]["width"]='550px';
    this.design["written_amount"]["index"]=false;
    this.design["written_amount_line"]["borders"]=false;
    this.design["written_amount_line"]["overflow"]=true;
    this.design["written_amount_line"]["top"]='0px';
    this.design["written_amount_line"]["right"]='0px';
    this.design["written_amount_line"]["bottom"]='0px';
    this.design["written_amount_line"]["left"]='0px';
    this.design["written_amount_line2"]["top"]='4mm';
    this.design["written_amount_line2"]["right"]='0mm';
    this.design["written_amount_line2"]["bottom"]='0mm';
    this.design["written_amount_line2"]["left"]='0mm';
    this.design["multiline_written_amount_chars"]=62;
    this.design["amounts"]["symbol"]=false;
    this.design["amount_number"]["borders"]=false;
    this.design["amount_number"]["background"]=false;
    this.design["amount_number"]["top"]="0.8mm";
    this.design["amount_number"]["right"]="auto";
    this.design["amount_number"]["left"]="-3.1mm";
    this.design["memo"]["label"]=true;
    this.design["memo"]["border"]=false;
    this.design["memo"]["bordercolor"]='#815836';
    this.design["memo"]["left"]='13.5mm';
    this.design["memo"]["right"]='auto';
    this.design["memo"]["bottom"]='8.5mm';
    this.design["memo"]["width"]='138mm';
    this.design["memo"]["fontsize"]='';
    this.design["public_image"]["top"]='34.1mm';//'26.5mm';
    this.design["public_image"]["left"]='130.3mm';//'32.3mm';
    this.design["public_image"]["width"]='77';
    this.design["public_image"]["zindex"]='1';
    this.design['public_image']['QRcolorDark']="#000000";
    this.design['public_image']['QRcolorLight']="#f4eab2";
    this.design['public_image']['QRCodeMargin']="1";
    this.design["key_image"]["width"]='77';
    this.design["key_image"]["left"]='13mm';
    this.design["key_image"]["top"]='20mm';
    this.design["key_image"]["zindex"]='1';
    this.design['key_image']['QRcolorDark']="#000000";
    this.design['key_image']['QRcolorLight']="#f0e4aa";
    this.design['key_image']['QRCodeMargin']="1";
    this.design["currency_name"]["top"]='28.7mm';
    this.design["currency_name"]["left"]='74mm';
    this.design["address_data"]["top"]='19.5mm';
    this.design["address_data"]["left"]='29.9mm';
    this.design["address_data"]["width"]='169mm';
    this.design["signature"]["width"]='180px';
    this.design["signature"]["container_width"]='56.7mm';
    this.design["signature"]["border"]=false;
    this.design["signature"]["label"]=false;
    this.design["signature"]["right"]='auto';
    this.design["signature"]["bottom"]='24.6mm';
    this.design["signature"]["left"]='41.9mm';
    this.design["micr"]["top"]='auto';
    this.design["micr"]["right"]='auto';
    this.design["micr"]["bottom"]='2.3mm';
    this.design["micr"]["left"]='8mm';
    this.design["micr"]["background"]=true;
    if(this.sql.model=='web') {
      var img = "golden";
      this.sql.load_background(img,(base64Img)=>{
        this.bg_image=base64Img;
      },this.sql.production);
    } else {
      this.bg_image = this.sql.production?backgrounds.golden:backgrounds_lowrez.golden;
    }
}
}